// removed by extract-text-webpack-plugin
module.exports = {"wrapper-shapes__geometric":"magazines_2flT8"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Editor/components/Shapes/styles.scss
// module id = 1058
// module chunks = 1